import TopBar from '@/components/feature/TopBar';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import StepsSection from './components/StepsSection';
import WhyChooseSection from './components/WhyChooseSection';
import SolidaritySection from './components/SolidaritySection';
import TestimonialsSection from './components/TestimonialsSection';
import EmergencyCTA from './components/EmergencyCTA';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <>
      <TopBar />
      <Navbar />
      <main>
        <HeroSection />
        <StatsBar />
        <AboutSection />
        <ServicesSection />
        <StepsSection />
        <WhyChooseSection />
        <SolidaritySection />
        <TestimonialsSection />
        <EmergencyCTA />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}